import React from 'react';
import cx from 'classnames';
import {Title, Text} from '@priority-software/priority-style-react';
import styles from '../../styles.module.scss';

type Props = {
    text: string;
    stepNumber: number;
    isActive: boolean;
    isCompleted: boolean;
    isDisabled: boolean;
};

export const Step = (props: Props) => {
    const {text, stepNumber, isActive, isDisabled} = props;

    return (
        <div
            className={cx(styles.step, {
                [styles.activeStep]: isActive,
                [styles.disabledStep]: isDisabled
            })}
        >
            <Title skin="h1">{stepNumber}.</Title>
            <Text tag="div" skin="paragraph-1">
                {text}
            </Text>
        </div>
    );
};
